import AssignNumberForm from "Components/Device/InboundNumber/AssignNumberForm";
import SimpleLoader from "Components/Shared/SimpleLoader";
import { useDDI, useNumberPool } from "Hooks/Endpoints";
import React, { useEffect, useState } from "react";
import PortNumberForm from "./PortNumberForm";
import InboundNumber from "./InboundNumber";
import InboundNumberList from "./InboundNumberList";
import AllocateNumberForm from "./AllocateNumberForm";
import APITicketProvider from "Providers/APITicketProvider";

const InboundNumbers = () => {
  const { ddi, loading } = useDDI();
  const { search: searchPool } = useNumberPool();
  const [view, setView] = useState<string>("list");

  useEffect(() => {
    if (view) {
      searchPool("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [view]);

  return (
    <SimpleLoader loading={loading}>
      {ddi && <InboundNumber />}
      {!ddi && view === "list" && <InboundNumberList onActiveView={setView} />}
      {!ddi && view === "pool" && (
        <AssignNumberForm
          onBack={() => setView("list")}
          onComplete={() => setView("list")}
        />
      )}
      {!ddi && view === "import" && (
        <APITicketProvider>
          <PortNumberForm onBack={() => setView("list")} />
        </APITicketProvider>
      )}
      {!ddi && view === "allocate" && (
        <APITicketProvider>
          <AllocateNumberForm onBack={() => setView("list")} />
        </APITicketProvider>
      )}
    </SimpleLoader>
  );
};

export default InboundNumbers;
